import { gql } from "@apollo/client";

export const ORGANIZATIONS = gql`
  query Organizations(
    $where: OrganizationWhereInput
    $take: Int
    $skip: Int
    $like: OrganizationWhereInput
  ) {
    organizations(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        type
        hosting
        active
        siretNumber
        telecoms {
          id
          system
          value
        }
        counterpartyContracts {
          id
          legalState
          expirationType
          type
          issuanceDate
          createdDate
        }
        users {
          id
          gender
          firstname
          lastname
          phone
          email
          meta
        }
      }
      count
    }
  }
`;

export const ORGANIZATION = gql`
  query Organization($where: OrganizationWhereInput, $exclude: [String]) {
    organization(where: $where, exclude: $exclude) {
      id
      name
      type
      hosting
      active
      siretNumber
      form
      icon
      additionalInfo
      config {
        envelop
        template
        useQuoteDownloadLinks
        emailConfig {
          disabled
          email
        }
        EFFICIAL_CLIENT_ID
        aircall {
          enabled
        }
        globalProjectsViewEnabled
        hotList {
          enabled
          sourceName
          signalFeed
        }
        leadTypologyEnabled
      }
      broker {
        id
      }
      telecoms {
        id
        system
        value
      }
      counterpartyContracts {
        id
        identifier
        legalState
        expirationType
        type
        issuanceDate
        createdDate
        subjects
      }
      users {
        id
        gender
        firstname
        lastname
        phone
        email
        meta
      }
    }
  }
`;

export const CONTRACT_LINKED_ORGANIZATIONS = gql`
  query ContractLinkedOrganizations(
    $where: OrganizationWhereInput
    $take: Int
    $skip: Int
  ) {
    organizations(where: $where, take: $take, skip: $skip) {
      data {
        id
        name
        type
        active
        siretNumber
        additionalInfo
        telecoms {
          id
          system
          value
        }
      }
      count
    }
  }
`;

export const ORGANIZATION_BRANCHES = gql`
  query OrganizationBranches($where: OrganizationWhereInput) {
    organizationBranches(where: $where) {
      count
      data {
        id
        name
        type
        telecoms {
          value
        }
      }
    }
  }
`;

export const ORGANIZATION_SETUP = gql`
  query OrganizationSetup($where: OrganizationWhereInput!) {
    organizationSetup(where: $where) {
      productRanges
      insurancePlans
      pricers
      distributions
      emailTemplates
      reminders
    }
  }
`;

export const ORGANIZATION_ENCRYPTION = gql`
  query OrganizationEncryption($where: OrganizationWhereInput!) {
    organizationEncryption(where: $where) {
      status
      mode
      keyArn
      expiresAt
      activatedAt
      verifiedAt
      importValidTo
      region
      identity
      keyPolicy
      handover {
        email
        expiresAt
        open
      }
    }
  }
`;

export const ORGANIZATION_API_ACCESS = gql`
  query OrganizationApiAccess($where: OrganizationWhereInput!) {
    organizationApiAccess(where: $where) {
      enabled
      issuer
      tokenUrl
      apiUrl
      scope
      credentials {
        id
        createdDate
        label
        method
        userId
        clientId
        keyId
        keyExpiresAt
        allowedIps
        enabled
        usageCount
        lastUsedAt
        pending
        handover {
          email
          expiresAt
          open
        }
      }
    }
  }
`;

export const ORGANIZATION_ENVIRONMENT = gql`
  query OrganizationEnvironment($where: OrganizationWhereInput!) {
    organizationEnvironment(where: $where) {
      hosting
      url
      ready
    }
  }
`;

const organizations = {
  ORGANIZATIONS,
  ORGANIZATION,
  ORGANIZATION_BRANCHES,
  ORGANIZATION_SETUP,
  ORGANIZATION_ENCRYPTION,
  ORGANIZATION_API_ACCESS,
  ORGANIZATION_ENVIRONMENT,
  CONTRACT_LINKED_ORGANIZATIONS,
};

export default organizations;
